import { render, staticRenderFns } from "./DocsUserManualChapter1.vue?vue&type=template&id=5a0a88d8&scoped=true&"
var script = {}
import style0 from "./DocsUserManualChapter1.vue?vue&type=style&index=0&id=5a0a88d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a88d8",
  null
  
)

export default component.exports